<template>

  <div class="news" style="margin-top: 40px">
    <div class="container-width">
      <div class="banner">
        <div class="banner-txt">
          <p class="banner-title">
            单身人群交友难题何解？
            <br data-v-28217f47="">
            心链交友或能给出答案
          </p>
          <p class="banner-subtitle">
            第七次全国人口普查大数据报告显示，我国15岁-59岁人数为89438万人，占总人口63.35%，而其中…
          </p> 
          <a href="https://new.qq.com/omn/20210820/20210820A07L0S00?refer.html"
             target="_blank" class="banner-btn arrow-more">
            阅读全文
          </a>
        </div>
        <div class="banner-img">
          <img src="../../assets/img/img_love.a5414878.png">
        </div>
      </div>
      <div class="news-list-box">
        <ul class="news-list clf">
          <li class="news-item">
            <p class="news-banner">
              <a href="https://mp.weixin.qq.com/s/m4BWId3uCvcVLDsmitC2vA"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_1.463af739.png" alt="心链x齐鲁晚报发布纪录片|《小镇青年婚恋社会观察纪实》">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://mp.weixin.qq.com/s/m4BWId3uCvcVLDsmitC2vA"
                 target="_blank">
                心链x齐鲁晚报发布纪录片|《小镇青年婚恋社会观察纪实》
              </a>
            </p>
            <p class="news-time">
              2023年9月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://mp.weixin.qq.com/s/yPEpQ0YNfot0AxnlITnW_g"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_2.22c802f1.png" alt="心链亮相千佛山相亲大会 线上线下联动助力适婚青年脱单">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://mp.weixin.qq.com/s/yPEpQ0YNfot0AxnlITnW_g"
                 target="_blank">
                心链亮相千佛山相亲大会 线上线下联动助力适婚青年脱单
              </a>
            </p>
            <p class="news-time">
              2023年8月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://mp.weixin.qq.com/s/Ko_0UmoGAjvS4v-2P_hocQ"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_3.02d18cde.png" alt="【中国网专访】安全、真实、绿色心链以科技创新推动小镇青年婚育高质量">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://mp.weixin.qq.com/s/Ko_0UmoGAjvS4v-2P_hocQ"
                 target="_blank">
                【中国网专访】安全、真实、绿色心链以科技创新推动小镇青年婚育高质量
              </a>
            </p>
            <p class="news-time">
              2023年8月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://mp.weixin.qq.com/s/wtVbkJ86548vdNylXr2JzA"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_4.ec1644bb.png" alt="人民网x心链用户特别采访：年轻人为什么不愿意？">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://mp.weixin.qq.com/s/wtVbkJ86548vdNylXr2JzA"
                 target="_blank">
                人民网x心链用户特别采访：年轻人为什么不愿意？
              </a>
            </p>
            <p class="news-time">
              2023年8月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://mp.weixin.qq.com/s/3vo38vOWI2BhgmkuKHOLrw"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_5.5da09ca5.jpg" alt="心链黄俊杰参加中国网络文明大会 聚焦“网生代”青年健康社交做分享">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://mp.weixin.qq.com/s/3vo38vOWI2BhgmkuKHOLrw"
                 target="_blank">
                心链黄俊杰参加中国网络文明大会 聚焦“网生代”青年健康社交做分享
              </a>
            </p>
            <p class="news-time">
              2023年7月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://www.sznews.com/news/content/2023-06/01/content_30252406.htm"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_6.499dd5fa.jpg" alt="心链脱单观影团齐聚深圳万象天地《蜘蛛侠：纵横宇宙》超前观影会">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://www.sznews.com/news/content/2023-06/01/content_30252406.htm"
                 target="_blank">
                心链脱单观影团齐聚深圳万象天地《蜘蛛侠：纵横宇宙》超前观影会
              </a>
            </p>
            <p class="news-time">
              2023年6月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://cj.sina.com.cn/articles/view/7822232632/1d23dcc38020015os7"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_7.6ab4e4d9.jpg" alt="心链母亲节“100位时光美人”感恩活动暖心举办">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://cj.sina.com.cn/articles/view/7822232632/1d23dcc38020015os7"
                 target="_blank">
                心链母亲节“100位时光美人”感恩活动暖心举办
              </a>
            </p>
            <p class="news-time">
              2023年5月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="http://www.fj.chinanews.com.cn/news/2023/2023-05-21/524933.html"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_8.4671a5e9.jpg" alt="有爱就要说出来：厦门十里长堤首届表白节启动">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="http://www.fj.chinanews.com.cn/news/2023/2023-05-21/524933.html"
                 target="_blank">
                有爱就要说出来：厦门十里长堤首届表白节启动
              </a>
            </p>
            <p class="news-time">
              2023年5月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="http://m.people.cn/n4/2023/0420/c1142-20555798.html"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_9.8f40041a.png" alt="心链11周年故事片上线 透视当代单身青年的“冷”与“热”">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="http://m.people.cn/n4/2023/0420/c1142-20555798.html"
                 target="_blank">
                心链11周年故事片上线 透视当代单身青年的“冷”与“热”
              </a>
            </p>
            <p class="news-time">
              2023年4月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://baijiahao.baidu.com/s?id=1759892684817435502"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_10.260bc4bd.jpeg" alt="心链绽放公益力量，关爱顶梁柱妈妈暖人心">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://baijiahao.baidu.com/s?id=1759892684817435502"
                 target="_blank">
                心链绽放公益力量，关爱顶梁柱妈妈暖人心
              </a>
            </p>
            <p class="news-time">
              2023年3月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://henan.china.com/news/roll/2023/0220/022023_353621.html"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_11.08e91856.png" alt="构筑信息安全堡垒！心链内容风控部负责人荣获“优秀安全员”奖">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://henan.china.com/news/roll/2023/0220/022023_353621.html"
                 target="_blank">
                构筑信息安全堡垒！心链内容风控部负责人荣获“优秀安全员”奖
              </a>
            </p>
            <p class="news-time">
              2023年2月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://mp.weixin.qq.com/s/Yc9AXDUzzojIDzv6LklR9w"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_12.a8b5b6b8.jpg" alt="2023心链发布首份婚恋社交白皮书：超四成女性表示不要彩礼!">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://mp.weixin.qq.com/s/Yc9AXDUzzojIDzv6LklR9w"
                 target="_blank">
                2023心链发布首份婚恋社交白皮书：超四成女性表示不要彩礼!
              </a>
            </p>
            <p class="news-time">
              2023年2月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="http://zh.rmjtxw.com/20230208/200374.html"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_13.bee7057b.png" alt="相识到奔现，心链洞察线上交友四大阶段要领">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="http://zh.rmjtxw.com/20230208/200374.html"
                 target="_blank">
                相识到奔现，心链洞察线上交友四大阶段要领
              </a>
            </p>
            <p class="news-time">
              2023年2月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="http://fj.people.com.cn/n2/2023/0120/c181466-40275516.html"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_14.2011affe.png" alt="如何应对春节催婚？心链解构新生代婚恋问题">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="http://fj.people.com.cn/n2/2023/0120/c181466-40275516.html"
                 target="_blank">
                如何应对春节催婚？心链解构新生代婚恋问题
              </a>
            </p>
            <p class="news-time">
              2023年1月
            </p>
          </li>
          <li class="news-item">
            <p class="news-banner">
              <a href="https://baijiahao.baidu.com/s?id=1754889554268411682&amp;wfr=spider&amp;for=pc"
                 target="_blank">
                <img src="../../assets/img/2023_9_8_15.3b36d50f.png" alt="婚恋社交领域首份透明度报告发布，心链筑牢社交安全“金钟罩”">
              </a>
            </p>
            <p class="news-title ellipsis-multi">
              <a href="https://baijiahao.baidu.com/s?id=1754889554268411682&amp;wfr=spider&amp;for=pc"
                 target="_blank">
                婚恋社交领域首份透明度报告发布，心链筑牢社交安全“金钟罩”
              </a>
            </p>
            <p class="news-time">
              2023年1月
            </p>
          </li>
          
        </ul>
      </div>
    </div>
  </div>



</template>

<script>
  export default {
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .news{
    padding-top:10px
  }
  .banner{
    height:306px;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between
  }
  .banner-title{
    font-size:42px;
    color:#353535;
    line-height:56px
  }
  .banner-txt{
    width:470px;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-direction:column;
    flex-direction:column;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center
  }
  .banner-subtitle{
    line-height:28px;
    font-size:19px;
    color:rgba(0,0,0,.55);
    padding-top:8px
  }
  .banner-btn{
    font-size:14px;
    color:#e4bf58;
    padding-right:20px;
    margin-top:33px;
    width:82px;
    display:inline-block
  }

  .arrow-more {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJBAMAAADjtECuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExUReTAWEdwTOfCWeS/WejDXefBW+XAWeW/WObBWuXAWefAWuTBWOW/WezGXncz7JIAAAAOdFJOU+sANeYiK1jdPktBa2QbUyIrtwAAACxJREFUCNdjaFAUZJBkFWQQTHZkEJSpZRAU3M4gKGbCIDg5kEGKSZBBoVEQAF1yBUlAOug5AAAAAElFTkSuQmCC) right 50% no-repeat;
  }

  .banner-img{
    width:580px;
    height:306px;
    overflow:hidden
  }
  .news-list-box{
    overflow:hidden;
    padding-top:40px;
    padding-bottom:80px
  }
  .news-list{
    width:1120px
  }
  .news-item{
    width:310px;
    height:290px;
    margin-right:60px;
    margin-top:40px;
    float:left
  }
  .news-item a{
    display:block;
    color:rgba(0,0,0,.55);
    font-size:14px;
    line-height:22px
  }
  .news-item a:hover {
    text-decoration:underline
  }
  .news-banner{
    width:310px;
    height:162px;
    overflow:hidden
  }
  .news-banner img{
    width:310px;
    height:162px;
    -o-object-fit:cover;
    object-fit:cover
  }
  .news-title{
    padding-top:10px;
    height:60px
  }
  .news-title a{
    font-size:19px;
    line-height:24px;
    color:rgba(0,0,0,.55)
  }
  .news-time{
    color:rgba(0,0,0,.36);
    padding-top:14px;
    font-size:19px
  }


  .container-width {
    width:1060px;
    margin:0 auto
  }
  
</style>



// WEBPACK FOOTER //
// src/views/News.vue